module.exports = __webpack_public_path__ + "media/images/components/map-icons/contacts-map-pin-major_candidate-5cd3f7995d98c2e1a1feb565c3eee850.png";